import { defineMessages } from 'react-intl';

export default defineMessages({
    reason: {
        id: 'ent.directives.cancel-policy.Reason',
        defaultMessage: 'Reason',
    },
    cancellationCreatedDate: {
        id: 'ent.views.cancellation-detail.Cancellation Created Date',
        defaultMessage: 'Cancellation Created Date',
    },
    continueCancellation: {
        id: 'ent.views.cancellation-detail.Continue Cancellation',
        defaultMessage: 'Continue Cancellation',
    },
    refundMethod: {
        id: 'ent.directives.cancel-policy.Refund Method',
        defaultMessage: 'Refund Method',
    },
    policy: {
        id: 'ent.views.cancellation-detail.Policy',
        defaultMessage: 'Policy',
    },
    account: {
        id: 'ent.views.cancellation-detail.Account',
        defaultMessage: 'Account',
    },
    customerCancellations: {
        id: 'ent.directives.cancel-policy.Please only initiate customer requested cancellations',
        defaultMessage:
            'Please initiate cancellations requested by customers only.',
    },
    customerCancellationsUnderwriter: {
        id: 'ent.directives.cancel-policy.For all other cancellations please create an activity for your underwriter',
        defaultMessage:
            'For all other cancellations, create an activity for your underwriter.',
    },
    cancellationMessageTFPA: {
        id: 'ent.directives.cancel-policy.TFPA.Any mailing address changes must be made before initiating a cancellation',
        defaultMessage: `
            Any mailing address changes must be made before initiating a cancellation.
            Supporting documents may be uploaded after initiating the cancellation.
            Any WPI-8 Waiver Surcharges applied are fully earned.`
    },
    cancellationMessageOne: {
        id: 'ent.directives.cancel-policy.Any mailing address changes must be made before initiating a cancellation',
        defaultMessage: 'Any mailing address changes must be made before initiating a cancellation.'
    },
    cancellationMessageTwo: {
        id: 'ent.directives.cancel-policy.Supporting documents must be uploaded for all cancellation reasons except "Insured\'s Request"',
        defaultMessage: 'Supporting documents must be uploaded for all cancellation reasons except "Insured\'s Request."'
    },
    cancellationMessageThree: {
        id: 'ent.directives.cancel-policy.Any WPI-8 Waiver Surcharges applied are fully earned',
        defaultMessage: 'Any WPI-8 Waiver Surcharges applied are fully earned.'
    },
    startCancellation: {
        id: 'ent.directives.cancel-policy.Start Cancellation',
        defaultMessage: 'Start Cancellation',
    },
    donotCancel: {
        id: 'ent.directives.cancel-policy.Do Not Cancel',
        defaultMessage: 'Do Not Cancel',
    },
    descriptionPolicy: {
        id: 'ent.directives.cancel-policy.Description',
        defaultMessage: 'Description',
    },
    selectAfterDate: {
        id: 'ent.directives.cancel-policy.Please set a date that is after the start date of the policy',
        defaultMessage:
            'The Effective Date of cancellation cannot be earlier than the effective date of the policy',
    },
    selectBeforeDate: {
        id: 'ent.directives.cancel-policy.Please set a date that is before the expiry date of the policy',
        defaultMessage:
            'The Effective Date of cancellation cannot be on or after the expiration date of the policy',
    },
    selectInsuredDate: { //DE17098
        id: 'ent.directives.cancel-policy.The Effective Date of cancellation cannot be earlier than the current date',
        defaultMessage:
            'The Effective Date for Cancellation Reason “Insured’s Request” cannot be earlier than the current date. Please select a different Cancellation Reason if an earlier effective date is required.',
    },
    reasonPlcaeHolder: {
        id: 'ent.directives.cancel-policy.-- Please Choose --',
        defaultMessage: '-- Please Choose --',
    },
    unableToCancel: {
        id: 'ent.directives.cancel-policy.Unable to start cancellation',
        defaultMessage: 'Unable to start cancellation.',
    },
    unableToRetrieve: {
        id: 'ent.directives.cancel-policy.Unable to retreive Refund method and Effective date',
        defaultMessage: 'Unable to retreive Refund method and Effective date.',
    },
    close: {
        id: 'ent.directives.cancel-policy.Close',
        defaultMessage: 'Close',
    },
    dateMustmatch: {
        id: 'ent.directives.cancel-policy.Please enter a valid date (MM/DD/YYYY).',
        defaultMessage : 'Please enter a valid date (MM/DD/YYYY).'
    }
});
